export enum VatDeclarationsDropdownActionType {
  ChangePeriod = 'change-period',
  Export = 'export',
  SubmitManually = 'submit-manually',
  VoidPayment = 'void-payment',
  VoidSettlement = 'void-settlement',
}
